module.exports = "images/service_icon_04.svg";